import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Currency, DataTypeOptions, FuturePlan } from '@core/constants/data-types.constants';
import { getFieldError, isFieldInvalid, isFieldValid } from '@shared/utils/forms/validations.util';

@Component({
  selector: 'mfp-future-plan',
  templateUrl: './future-plan.component.html',
  styleUrls: ['./future-plan.component.scss']
})
export class FuturePlanComponent {
  @Input() form: FormGroup = new FormGroup({});
  @Input() label = '';
  @Input() readonly = false;
  @Input() required = false;

  @Input() currencyOptions: DataTypeOptions<Currency> = [];
  @Input() goalAmountName = '';
  @Input() goalAmountLabel = '';

  @Input() assuredAmountName = '';
  @Input() assuredAmountLabel = '';

  @Input() goalTypeName = '';
  @Input() goalTypeLabel = '';
  @Input() goalTypePlaceholder = '';
  @Input() goalTypeOptions: DataTypeOptions<FuturePlan> = [];
  @Input() goalTypeColor: 'primary' | 'light' = 'primary';

  @Input() dateName = '';
  @Input() dateLabel = '';
  @Input() datePlaceholder = '';
  @Input() dateErrorData: any;

  @Input() removeLabel = '';
  @Input() removeFill: 'default' | 'clear' | 'outline' = 'clear';
  @Input() removeSize: 'medium' | 'small' | 'tiny' = 'tiny';
  @Input() removeIcon = 'assets/icons/delete.svg';
  @Input() removeIconPosition: 'left' | 'right' = 'left';
  @Output() removeItem = new EventEmitter();

  isFieldValid = isFieldValid;
  isFieldInvalid = isFieldInvalid;
  getFieldError = getFieldError;

  remove(): void {
    this.removeItem.emit();
  }
}
